// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/QuickActionsSection.js
//
// Purpose:
// Dashboard Quick Actions
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import DashboardCard
  from "./DashboardCard";

export default function QuickActionsSection({

  onCreateTicket,

  onTicketList,

  onVisits,

  onFeedback,

  onSatisfaction,

  onReports,

}) {

  const actions = [

    {
      title: "Create Ticket",
      icon: "➕",
      color: "#2563eb",
      handler: onCreateTicket,
    },

    {
      title: "Ticket List",
      icon: "🎫",
      color: "#0f766e",
      handler: onTicketList,
    },

    {
      title: "Visits",
      icon: "🚗",
      color: "#ea580c",
      handler: onVisits,
    },

    {
      title: "Feedback",
      icon: "⭐",
      color: "#7c3aed",
      handler: onFeedback,
    },

    {
      title: "Satisfaction",
      icon: "😊",
      color: "#059669",
      handler: onSatisfaction,
    },

    {
      title: "Reports",
      icon: "📊",
      color: "#dc2626",
      handler: onReports,
    },

  ];

  return (

    <DashboardCard

      title="Quick Actions"

      subtitle="Frequently used Service CRM functions"

    >

      <div
        style={{
          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit, minmax(180px, 1fr))",

          gap: 16,
        }}
      >

        {actions.map((action, index) => (

          <div

            key={index}

            onClick={action.handler}

            style={{

              border:
                `1px solid ${action.color}`,

              borderRadius: 14,

              padding: 20,

              cursor: "pointer",

              textAlign: "center",

              transition:
                "all 0.2s ease",

              minHeight: 120,

              display: "flex",

              flexDirection: "column",

              justifyContent: "center",

              alignItems: "center",
            }}

            onMouseEnter={(e) => {

              e.currentTarget.style.transform =
                "translateY(-3px)";
            }}

            onMouseLeave={(e) => {

              e.currentTarget.style.transform =
                "translateY(0px)";
            }}
          >

            <div
              style={{
                fontSize: 34,
                marginBottom: 10,
              }}
            >
              {action.icon}
            </div>

            <div
              style={{
                fontSize: 14,

                fontWeight: 700,

                color: action.color,
              }}
            >
              {action.title}
            </div>

          </div>

        ))}

      </div>

    </DashboardCard>

  );
}